import React from 'react';
import { Route, Redirect, useLocation } from 'react-router-dom';

function CustomRoute({ isPrivate, ...rest }) {
  const location = useLocation();
  const userAuth = JSON.parse(localStorage.getItem('midias_kcc'));

  // Validação caso o usuario precisa atualizar os dados cadastrais
  if (
    rest.path === '/atualizar-dados' &&
    userAuth &&
    userAuth.atualizarDados === false
  ) {
    return <Redirect to="/" />;
  }

  if (
    userAuth &&
    userAuth.atualizarDados === true &&
    rest.path !== '/atualizar-dados'
  ) {
    return <Redirect to="/atualizar-dados" />;
  }

  if (isPrivate === true && (!userAuth || userAuth.authenticated === false)) {
    const path = location.pathname;
    // const queryParams = new URLSearchParams(location.search);
    // const parametro = queryParams.get('nomeDoParametro');
    // return <Redirect to={`/login?urlReturn=${rest.path}`} />;
    return <Redirect to={`/login?urlReturn=${path}`} />;
  }

  // eslint-disable-next-line react/jsx-props-no-spreading
  return <Route {...rest} />;
}

export default CustomRoute;
